import { render } from "./VentesParCategorie.vue?vue&type=template&id=48c022a6&scoped=true"
import script from "./VentesParCategorie.vue?vue&type=script&lang=js"
export * from "./VentesParCategorie.vue?vue&type=script&lang=js"

import "./VentesParCategorie.vue?vue&type=style&index=0&id=48c022a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c022a6"]])

export default __exports__